"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _utilities = require("../../utilities");
var _layers = require("../hooks/queries/layers");
var _toolbarButton = _interopRequireDefault(require("../map/components/toolbar-button"));
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _map = require("../map/geo-map/map");
var _trains = require("../map/geo-map/openlayers/trains");
var _helpers = require("../lib/helpers");
var _ghost = _interopRequireDefault(require("../../assets/icons/ghost.png"));
var _doubleTrain = _interopRequireDefault(require("../../assets/icons/double-train.png"));
var _doubleTrainInverted = _interopRequireDefault(require("../../assets/icons/double-train-inverted.png"));
var _staleTrain = _interopRequireDefault(require("../../assets/icons/stale-train.png"));
var _inferredLogin = _interopRequireDefault(require("../../assets/icons/inferred-login.png"));
var _canceledTrain = _interopRequireDefault(require("../../assets/icons/canceled-train.png"));
var _mapState = require("../hooks/mapState");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ICON_MAP = {
  isGhost: _ghost["default"],
  isDuplicate: _doubleTrain["default"]
};
var INITIAL_SEARCH_STATE = {
  openSearch: false,
  query: "",
  sortProp: 'delay',
  sortDesc: false,
  filter: 'all'
};
var TrainList = function TrainList(props) {
  var _mapState$auth, _mapState$trains, _mapState$trains$feat;
  var _useState = (0, _react.useState)(INITIAL_SEARCH_STATE),
    _useState2 = _slicedToArray(_useState, 2),
    searchState = _useState2[0],
    setSearchState = _useState2[1];
  var _useMapState = (0, _mapState.useMapState)(),
    mapState = _useMapState.mapState,
    newSetSelected = _useMapState.newSetSelected,
    unselect = _useMapState.unselect;
  var playback = mapState.playback;
  var inputRef = (0, _react.useRef)();
  // console.log('search state? ', searchState)
  // const { trains } = mapState;
  var _getTrainPositions = (0, _layers.getTrainPositions)(mapState === null || mapState === void 0 ? void 0 : (_mapState$auth = mapState.auth) === null || _mapState$auth === void 0 ? void 0 : _mapState$auth.mapLayerToken),
    trainPositionData = _getTrainPositions.data;
  var handleOpenSearch = function handleOpenSearch() {
    setSearchState(_objectSpread(_objectSpread({}, searchState), {}, {
      openSearch: true
    }));
    // this.setState({ openSearch: true }, () => this.refs.input && this.refs.input.focus())
  };

  var setSort = function setSort(column) {
    if (column == searchState.sortProp) {
      setSearchState(_objectSpread(_objectSpread({}, searchState), {}, {
        sortDesc: !searchState.sortDesc
      }));
    } else {
      setSearchState(_objectSpread(_objectSpread({}, searchState), {}, {
        sortProp: column,
        sortDesc: false
      }));
    }
  };
  var getGhostNextStopText = function getGhostNextStopText(train) {
    var result = null;
    if (train.schedule) {
      var todayStr = (0, _moment["default"])().startOf('day').format('YYYY-MM-DD');
      var now = (0, _moment["default"])();
      var stopsWithArrivalDiff = train.schedule.map(function (stop) {
        var arrival = (0, _moment["default"])(todayStr + 'T' + stop.arrival, "YYYY-MM-DDTHH:mm:ss");
        return {
          diff: now.diff(arrival, 'seconds'),
          arrival: arrival,
          arrivalStr: stop.arrival,
          name: stop.name
        };
      });
      var futureStops = stopsWithArrivalDiff.filter(function (stop) {
        return stop.diff <= 0;
      });
      if (futureStops.length) {
        var nextStop = _lodash["default"].minBy(futureStops, function (stop) {
          return Math.abs(stop.diff);
        });
        result = nextStop.name;
      } else if (stopsWithArrivalDiff.length) {
        var lastStop = _lodash["default"].last(stopsWithArrivalDiff);
        if (lastStop) {
          result = lastStop.name;
        }
      }
    }
    return result;
  };
  var getIcons = function getIcons(train, isSelected, playback) {
    var _train$vehicle_status, _train$boarding_statu;
    var icons = [];
    // Handle alerts from backend
    var isGhost = (train === null || train === void 0 ? void 0 : (_train$vehicle_status = train.vehicle_status) === null || _train$vehicle_status === void 0 ? void 0 : _train$vehicle_status.toLowerCase()) === 'ghost';
    var isInferred = (train === null || train === void 0 ? void 0 : train.inferred_login) === true;
    var isCancelled = (train === null || train === void 0 ? void 0 : (_train$boarding_statu = train.boarding_status) === null || _train$boarding_statu === void 0 ? void 0 : _train$boarding_statu.toLowerCase()) === 'cancelled';
    var isDouble = train === null || train === void 0 ? void 0 : train.double_id;
    var isMissingAcses = (0, _utilities.hasMissingAcsesAlert)(train);
    var isMissingAvl = (0, _utilities.hasMissingAvlAlert)(train);
    var isBadAvl = (0, _utilities.hasBadAvlAlert)(train);
    if (isGhost) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "ghost",
        placement: "top",
        overlay: "Ghost Train",
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        key: "ghost",
        src: _ghost["default"]
      })));
    }
    if (isInferred) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "inferred-login",
        placement: "top",
        overlay: "Inferred Login",
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        key: "ghost",
        src: _inferredLogin["default"]
      })));
    }
    if (isDouble) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "duplicate",
        placement: "top",
        overlay: "Double Train",
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: isSelected ? _doubleTrainInverted["default"] : _doubleTrain["default"]
      })));
      icons.push();
    }
    if (isCancelled) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "canceled",
        placement: "top",
        overlay: "Train Canceled",
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        key: "ghost",
        src: _canceledTrain["default"]
      })));
    }
    if (isMissingAcses) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "missing-acses",
        placement: "top",
        overlay: /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, "No ACSES", /*#__PURE__*/_react["default"].createElement("br", null), " transponder data"),
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faTowerBroadcast,
        color: "#727272",
        size: "lg"
      }))));
    }
    if (isMissingAvl) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "missing-avl",
        placement: "top",
        overlay: /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, "No AVL", /*#__PURE__*/_react["default"].createElement("br", null), " connectivity"),
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faWifi,
        color: "#727272",
        size: "lg"
      }))));
    }
    if (isBadAvl) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "bad-avl",
        placement: "top",
        overlay: /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, "Bad AVL", /*#__PURE__*/_react["default"].createElement("br", null), " data"),
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faWifi,
        color: "#dc3545",
        size: "lg"
      }))));
    }
    train.alerts && train.alerts.forEach(function (alert) {
      switch (alert) {
        case "inferredLogin":
          icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
            key: "inferred-login",
            placement: "top",
            overlay: "Inferred Login",
            arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
              className: "rc-tooltip-arrow-inner"
            })
          }, /*#__PURE__*/_react["default"].createElement("img", {
            key: "ghost",
            src: _inferredLogin["default"]
          })));
          break;
        case "isDuplicate":
          icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
            key: "duplicate",
            placement: "top",
            overlay: "Double Train",
            arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
              className: "rc-tooltip-arrow-inner"
            })
          }, /*#__PURE__*/_react["default"].createElement("img", {
            src: isSelected ? _doubleTrainInverted["default"] : _doubleTrain["default"]
          })));
          icons.push();
          break;
        case "isGhost":
          icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
            key: "ghost",
            placement: "top",
            overlay: "Ghost Train",
            arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
              className: "rc-tooltip-arrow-inner"
            })
          }, /*#__PURE__*/_react["default"].createElement("img", {
            key: "ghost",
            src: _ghost["default"]
          })));
          break;
        case "isCanceled":
          icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
            key: "canceled",
            placement: "top",
            overlay: "Train Canceled",
            arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
              className: "rc-tooltip-arrow-inner"
            })
          }, /*#__PURE__*/_react["default"].createElement("img", {
            key: "ghost",
            src: _canceledTrain["default"]
          })));
      }
    });

    // add in stale train indicator
    if (!playback.isPlaying && playback.timestamp && (0, _utilities.trainIsStale)(train)) {
      icons.push( /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "stale",
        placement: "top",
        overlay: "Stale Data (> 5 min)",
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "rc-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: _staleTrain["default"]
      })));
    }
    return icons;
  };
  var dummyGhostTrain = {
    id: "Keolis ghost-821",
    type: "Feature",
    properties: {
      vehicle: "ghost-821",
      trip_short_name: "821",
      latitude: 41.86265381099054,
      longitude: -71.40507617604203,
      timestamp: 1697660760,
      operator: "Keolis",
      shape_id: "9890009",
      next_stop: "Providence",
      vehicle_status: "GHOST",
      headsign: "Providence",
      double_id: false,
      STATE: "RI",
      MUNICIPALITY: "PAWTUCKET"
    },
    geometry: {
      type: "Point",
      coordinates: [-71.40507617604203, 41.86265381099054]
    }
  };
  // render() {
  var allTrains = props.trains,
    filter = props.filter,
    setFilter = props.setFilter;
  var selected = mapState.selected;
  var trains = mapState === null || mapState === void 0 ? void 0 : (_mapState$trains = mapState.trains) === null || _mapState$trains === void 0 ? void 0 : (_mapState$trains$feat = _mapState$trains.features) === null || _mapState$trains$feat === void 0 ? void 0 : _mapState$trains$feat.map(function (feat) {
    var trainProps = feat.properties;
    trainProps.delay = Math.round(trainProps.delay_sec / 60) || '';
    return trainProps;
  });
  var loweredQuery = searchState.query.toLowerCase();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "standalone-active-trains"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "panel-header dk-blue"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icons"
  }, searchState.openSearch ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("input", {
    className: "input-search-trains",
    style: {
      width: 150
    },
    value: searchState.query,
    onChange: function onChange(event) {
      return setSearchState(_objectSpread(_objectSpread({}, searchState), {}, {
        query: event.target.value
      }));
    },
    ref: inputRef
  }), /*#__PURE__*/_react["default"].createElement(_toolbarButton["default"], {
    label: "Close Search",
    icon: _freeSolidSvgIcons.faTimes,
    onClick: function onClick() {
      return setSearchState(_objectSpread(_objectSpread({}, searchState), {}, {
        openSearch: false,
        query: ""
      }));
    }
  })) : /*#__PURE__*/_react["default"].createElement(_toolbarButton["default"], {
    className: "btn-search-trains",
    label: "Search",
    icon: _freeSolidSvgIcons.faSearch,
    onClick: function onClick() {
      return handleOpenSearch();
    }
  })), /*#__PURE__*/_react["default"].createElement("h2", null, "Active Trains")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-wrapper",
    content: "user-scalable=no"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('alert');
    },
    className: (searchState.sortProp == 'alert' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : "") + " alerts-header"
  }, "Alert"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('train');
    },
    className: searchState.sortProp == 'train' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : ""
  }, "Train"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('vehicle');
    },
    className: searchState.sortProp == 'vehicle' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : ""
  }, "Vehicle"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('headsign');
    },
    className: searchState.sortProp == 'headsign' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : ""
  }, "Destination"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('speed');
    },
    className: (searchState.sortProp == 'speed' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : "") + " speed"
  }, "Speed"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('nextStop');
    },
    className: (searchState.sortProp == 'nextStop' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : "") + " next-stop"
  }, "Next Stop"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('track');
    },
    className: (searchState.sortProp == 'track' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : "") + " track"
  }, "Track"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setSort('delay');
    },
    className: searchState.sortProp == 'delay' ? searchState.sortDesc ? "sort-desc" : "sort-asc" : ""
  }, "Delay"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-body",
    style: {
      paddingBottom: '60px'
    }
  }, trains && trains.length > 0 ? _lodash["default"].orderBy(trains, _utilities.trainSortMap[searchState.sortProp] ? _utilities.trainSortMap[searchState.sortProp] : searchState.sortProp, searchState.sortDesc ? "desc" : "asc").filter(function (train) {
    return (0, _utilities.trainTaggedFilter)(train, filter);
  }).filter(function (train) {
    var tripShortNamePlaceholder = '';
    if (train.trip_short_name) {
      tripShortNamePlaceholder = train.trip_short_name;
    }
    return "".concat(tripShortNamePlaceholder).concat(train.vehicle).toLowerCase().indexOf(loweredQuery) > -1;
  }).map(function (train, index) {
    var isSelected = selected && selected.type == "train" && (train.vehicle ? selected.vehicle == train.vehicle : train.trip_short_name ? selected.id == train.trip_short_name : false);
    var boardingLocationText = (0, _utilities.getBoardingLocationText)(train);
    var posted_track_differs = false;
    var track_posted = train.track_posted,
      track_scheduled = train.track_scheduled;
    if (track_posted && track_posted !== track_scheduled) {
      posted_track_differs = true;
    }
    var ghostNextScheduledStop = null;
    if (train.alerts && train.alerts.includes('isGhost')) {
      ghostNextScheduledStop = getGhostNextStopText(train);
    }
    var destination = '';
    if (train.headsign) {
      destination = train.headsign;
    }
    if (ghostNextScheduledStop) {
      var destinationStop = _lodash["default"].last(train.schedule);
      if (destinationStop && destinationStop.name) {
        destination = destinationStop.name;
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "table-row" + (isSelected ? " active" : ""),
      key: "train".concat(train.trip_short_name ? "-TRIP-".concat(train.trip_short_name) : "").concat(train.vehicle ? "-VEHICLE-".concat(train.vehicle) : "-".concat(index)),
      onClick: function onClick() {
        var _selected$entireTrain;
        console.log('selected vs this train: ', selected, train);
        if (((_selected$entireTrain = selected.entireTrainObj) === null || _selected$entireTrain === void 0 ? void 0 : _selected$entireTrain.vehicleId) === train.vehicleId) {
          return unselect();
        }
        newSetSelected({
          type: 'train',
          id: train.trip_short_name ? train.trip_short_name : null,
          vehicle: train.vehicle ? train.vehicle : null,
          tripShortName: train.trip_short_name,
          vehicle_status: train.vehicle_status,
          entireTrainObj: train
        });
        if (train !== null && train !== void 0 && train.vehicleId) {
          (0, _helpers.zoomToTrain)(_trains.layer, _map.map, train.vehicleId);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "alerts"
    }, getIcons(train, isSelected, playback)), /*#__PURE__*/_react["default"].createElement("div", null, train.trip_short_name && train.trip_short_name), /*#__PURE__*/_react["default"].createElement("div", null, train.vehicle && train.vehicle), /*#__PURE__*/_react["default"].createElement("div", null, destination && /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
      key: "destination-".concat(index),
      placement: "top",
      overlay: destination,
      arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "rc-tooltip-arrow-inner"
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, destination))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "speed"
    }, Math.round(train.speed) || '0'), /*#__PURE__*/_react["default"].createElement("div", {
      className: "next-stop"
    }, boardingLocationText && /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
      key: "boarding-location-".concat(index),
      placement: "top",
      overlay: boardingLocationText,
      arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "rc-tooltip-arrow-inner"
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, boardingLocationText)), !!ghostNextScheduledStop && /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, ghostNextScheduledStop)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "track"
    }, posted_track_differs ? /*#__PURE__*/_react["default"].createElement("span", null, track_scheduled && /*#__PURE__*/_react["default"].createElement("del", {
      style: {
        textDecoration: 'line-through',
        color: 'red'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: '#495C6F'
      }
    }, "\xA0", track_scheduled, "\xA0")), " ", track_posted) : track_scheduled ? track_scheduled : ''), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "sa",
      style: train.delay > 4 ? {
        backgroundColor: (0, _utilities.getDelayColor)(train.delay)
      } : {}
    }, train.delay != undefined && train.delay != null && train.delay != 0 ? train.delay * -1 : "")));
  }) : /*#__PURE__*/_react["default"].createElement("div", null, "No trains loaded."))));
};
TrainList.propTypes = {
  trains: _propTypes["default"].array
};
var _default = TrainList;
exports["default"] = _default;